import { NgModule } from '@angular/core';
import { InitialNavigation, NavigationExtras, Router, RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { LandingPageComponent } from './pages/landing-page/landing-page.component';
import { RateAgreementComponent } from './pages/rate-agreement/rate-agreement.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { EditRateAgreementComponent } from './pages/edit-rate-agreement/edit-rate-agreement.component';
import { AuthComponent } from './pages/auth/auth.component';
import { ContactComponent } from './pages/contact/contact.component';
import { AddEditContactComponent } from './pages/add-edit-contact/add-edit-contact.component';
import { CarriersComponent } from './pages/carriers/carriers.component';
import { BidPacksComponent } from './pages/bid-packs/bid-packs.component';
import { FuelEscalatorComponent } from './pages/fuel-escalator/fuel-escalator.component';
import { EditFuelEscalatorComponent } from './pages/edit-fuel-escalator/edit-fuel-escalator.component';
import { EditBidpackComponent } from './pages/edit-bidpack/edit-bidpack.component';
import { EditCarrierComponent } from './pages/edit-carrier/edit-carrier.component';
import { authGuard } from './auth.guard';

const routes: Routes = [
  {path:"", pathMatch:'full', redirectTo:'login'},
  {path:"login", component:LoginComponent},
  {path:"auth", component:AuthComponent},
  {path:"home", component:LandingPageComponent,canActivate:[authGuard] },
  {path:"home/rate-agreement", component:RateAgreementComponent,canActivate:[authGuard]},
  {path:"home/rate-agreement/edit-agreement", component:EditRateAgreementComponent, canActivate:[authGuard]},
  {path:"home/contact", component:ContactComponent, canActivate:[authGuard]},
  {path:"home/contact/edit-contact", component:AddEditContactComponent, canActivate:[authGuard]},
  {path:"home/carrier", component:CarriersComponent, canActivate:[authGuard]},
  {path:"home/carrier/edit-carrier", component:EditCarrierComponent, canActivate:[authGuard]},
  {path:"home/bidpack", component:BidPacksComponent, canActivate:[authGuard]},
  {path:"home/bidpack/edit-bidpack", component:EditBidpackComponent, canActivate:[authGuard]},
  {path:"home/fuel-escalator", component:FuelEscalatorComponent, canActivate:[authGuard]},
  {path:"home/fuel-escalator/edit-fuel-escalator", component:EditFuelEscalatorComponent, canActivate:[authGuard]},
  
  {path:"page-not-found", component:PageNotFoundComponent},
  {path:"**", component:PageNotFoundComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
      initialNavigation: 'enabled' as InitialNavigation
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {
 }
